module.exports = __webpack_public_path__ + "img/ANTENNA FLOWER GREEN.34d29da.svg";